import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import PURCHASEIRQVaLoanBeforeView from "../views/IrqVaLoanBeforeView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object, bool } from "yup";
import StatusCheck from "../components/StatusCheck";

class PurchaseIrqVaLoanBeforePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="purchaseIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            vaFirstTimeUse: bool().required(),
          })}
        >
          <PURCHASEIRQVaLoanBeforeView
            content={contentMap.PurchaseIrqVaLoanBeforePage}
            navigationsAway={customNavigationMap.PurchaseIrqVaLoanBeforePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(PurchaseIrqVaLoanBeforePage);
